<template>
  <div>
    <AbadonedCartList />
  </div>
</template>

<script>
import AbadonedCartList from "@/components/Common/AbadonedCartList.vue";
export default {
  components: {
    AbadonedCartList
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
